import React from 'react';

import { MdLock } from 'react-icons/md';

import { Modal } from 'antd';

import {
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

export default function ModalInativarUsuario({
  modalInativar,
  inativarUsuario,
}) {
  const handleCancel = () => {
    inativarUsuario(false);
  };

  const handleOk = () => {
    inativarUsuario(true);
  };

  return (
    <Modal
      visible={modalInativar}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="Conferir depois"
      centered
      footer={null}
      width="480px"
    >
      <ModalContainer>
        <ModalHeader>
          <div className="iconModal">
            <span>
              <MdLock size={30} />
            </span>
          </div>
          <h2>
            <span>Deseja inativar a conta</span> deste usuário?
          </h2>
        </ModalHeader>
        <div className="ModalBody">
          <p>
            Uma vez inativado, o usuário perderá o direito de acessar o sistema.
            Deseja prosseguir?
          </p>
        </div>
      </ModalContainer>

      <ModalFooter>
        <ButtonModal type="button" onClick={handleOk}>
          Inativar usuário
        </ButtonModal>
        <ButtonModal type="button" cancel onClick={handleCancel}>
          Cancelar
        </ButtonModal>
      </ModalFooter>
    </Modal>
  );
}
